import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex items-center gap-2.5 border-b border-gray-200 bg-[#f9fafb] px-3.5 py-2.5" }
const _hoisted_3 = { class: "inline-grid h-8 w-8 place-items-center rounded-lg border border-gray-200 bg-white text-sm font-bold text-gray-800" }
const _hoisted_4 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_5 = { class: "w-32 flex-none text-gray-500" }
const _hoisted_6 = { class: "min-w-0 flex-1 text-gray-900" }


export default {
  __name: 'DateCards',
  props: { cards: { type: Array, default: () => [] } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card) => {
      return (_openBlock(), _createElementBlock("div", {
        key: card.title,
        "data-date-card": "",
        class: "overflow-hidden rounded-lg border border-gray-300"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(card.number), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(card.title), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.rows, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row.key + row.value,
            class: "flex items-center gap-2.5 border-t border-[#f3f4f6] px-3.5 py-2 text-sm"
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(row.key), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(row.value), 1)
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

}